var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33008 15.8333H8.3252V14.1666H3.33008V15.8333Z",
    fill: "#DC1928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99024 13.3333H3.33008V11.6666H9.99024V13.3333Z",
    fill: "#DC1928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9969 0.833313H0V19.1666H19.9969V0.833313ZM6.66563 6.56248V2.43748H1.55531V17.5625H18.4416V2.43748H13.3313V6.56248H6.66563ZM11.7759 4.95831H8.22094V2.43748H11.7759V4.95831Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/parcel.258bffdcd9eca1431c46602c3e7a6af5.svg";
export { ForwardRef as ReactComponent };